import React from 'react';
import classes from './HeaderItems.css';
import HeaderItem from './HeaderItem/HeaderItem';

const headerItems = (props) => (
    <ul className={classes.NavigationItems}>
        <HeaderItem id="welcome" link="/" active first display="true">Welcome {props.displayName}</HeaderItem>
        <HeaderItem id="logout" link="#" display="true" clicked={props.logoutHandler}>Logout</HeaderItem>
    </ul>
);

export default headerItems;